import { ContextualTabbedSettings } from '@components'

import { TabsItem } from '@shinetools/lumen-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'
import { EInvoicingSettings } from '@features/eInvoicingSettings'
import { ScoutConnections } from '@views/receipts/elements/ReceiptsSidePanel/elements/ScoutConnections'

import { Scope } from '../../../../enums/scope'
import { isAuthorized } from '../../../../utils/isAuthorized'
import { MagicMailSettings } from './elements/MagicMailSettings'

export const BillsSettings = () => {
  const { t } = useTranslation()
  const eInvoiceSettingsScopeEnabled = isAuthorized(Scope.EDocumentRead)
  const scoutWriteEnabled = isAuthorized(Scope.ScoutWrite)
  const isEInvoicingOnly = useIsEInvoicingOnly()

  const tabs = useMemo(() => {
    const innerTabs: TabsItem[] = []

    // TODO: handle ScoutUpsell ?
    if (scoutWriteEnabled) {
      innerTabs.push({
        value: 'scout',
        label: t('purchases.settings.copilot.title'),
        content: <ScoutConnections />,
      })
    }

    if (!isEInvoicingOnly) {
      innerTabs.push({
        value: 'magic-mail',
        label: t('purchases.settings.magicmail.title'),
        content: <MagicMailSettings />,
      })
    }

    if (eInvoiceSettingsScopeEnabled) {
      innerTabs.push({
        value: 'e-invoicing',
        label: t('purchases.settings.einvoicing.title'),
        content: <EInvoicingSettings context="Purchase" />,
      })
    }

    return innerTabs
  }, [t, scoutWriteEnabled, eInvoiceSettingsScopeEnabled, isEInvoicingOnly])

  return <ContextualTabbedSettings title={t('purchases.settings.title')} tabs={tabs} />
}
